import { createContext, useContext, useState } from "react";

const GradeContext = createContext(null);
const GRADE_KEY = "mitraa.selectedGrade";

export function GradeProvider({ children }) {
  // DEMO ONLY — replace with profile-assigned grade in production
  const [selectedGrade, setSelectedGradeState] = useState(() => {
    const saved = localStorage.getItem(GRADE_KEY);
    return saved ? parseInt(saved, 10) : 5; // Default: Grade 5
  });

  const setSelectedGrade = (grade) => {
    setSelectedGradeState(grade);
    localStorage.setItem(GRADE_KEY, grade.toString());
  };

  return (
    <GradeContext.Provider value={{ selectedGrade, setSelectedGrade }}>
      {children}
    </GradeContext.Provider>
  );
}

export const useGrade = () => useContext(GradeContext);
